/* @ngInject */
export function destinationOrganization(destinationService) {
    return destinationService.getDestinationOrganization();
}

/* @ngInject */
export function destinationInstallation(destinationService) {
    return destinationService.getDestinationInstallation();
}

/* @ngInject */
export function userSessions(userSessionService) {
    return userSessionService.getUserSessions();
}

/* @ngInject */
export function destinationSecurityContext(destinationService) {
    return destinationService.getDestinationSecurityContext();
}
